import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAllCompanies, getAssignedBanks } from '../../../middleware/backend_hepler';
import { FaEdit } from 'react-icons/fa';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from '../../../components/Loader';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Paginations from '../../../components/Paginations';


const CompanyList = () => {
  const [companyLists, setCompanyLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [messageDisplayed, setMessageDisplayed] = React.useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [companyPerPage, setBanksPerPage] = useState(10);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.successMessage && !messageDisplayed) {
      console.log(location.state.successMessage);
      toast.success(location.state.successMessage);
      setMessageDisplayed(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, navigate, messageDisplayed]);
  
  useEffect(() => {
    const fetchCompanyLists = async () => {
      try {
        const response = await getAllCompanies();
        const filtered = response.data.filter(
          (company) => company.company_name !== "Others"
        );

        setCompanyLists(filtered);
        setLoading(false);
      } catch (error) {
        setError('Error fetching company lists.');
        setLoading(false);
      }
    };
    fetchCompanyLists();
  }, []);
 
  useEffect(() => {
    setLoading(true)
    const fetchAssignedBanks = async () => {
      const allBankIds = [
        ...new Set(
          companyLists
            .map((c) => {
              try {
                const parsed = JSON.parse(c.bank_list);
                return parsed ?? [];
              } catch {
                return [];
              }
            })
            .flat()
        ),
      ];

      try {
        const response = await getAssignedBanks(allBankIds);
        setBankLists(response.data);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching assigned banks:", error);
        setError("Error fetching Bank lists.");
      }
    };

    if (companyLists.length > 0) {
      fetchAssignedBanks();
    }
  }, [companyLists]);

  const getBankNames = (bankListStr) => {
    if (!bankListStr) return "";

    let ids;
    try {
      ids = JSON.parse(bankListStr);
    } catch {
      return "";
    }

    if (!Array.isArray(ids)) return "";

    const names = ids
      .map((id) =>
        bankLists.find((bank) => Number(bank.bank_id) === Number(id))?.bank_name
      )
      .filter(Boolean);

    return names.join(", ");
  };

  const handleStaffButtonClick = () => {
    navigate("/create-company");
  };

  const handleEdit = (id) => {
    navigate(`/edit-company/${id}`);
  };


  const handleBulkUpload = () => {
    navigate(`/company-bulk-upload`);
  };

    const handleBulkDelete = () => {
    navigate(`/company-bulk-delete`);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  if (loading) {
    return <Loader/>;
  }
  if (error) {
    return <div>{error}</div>;
  }

  const filteredCompanyLists = companyLists.filter((company) => {
    const searchQueryLower = searchQuery.toLowerCase();

    const matchesCompanyName = company.company_name
      ?.toLowerCase()
      .includes(searchQueryLower);

    const bankNames = getBankNames(company.bank_list).toLowerCase();
    const matchesBankList = bankNames.includes(searchQueryLower);

    const matchesPincode = company.company_pincode
      ?.toString()
      .toLowerCase()
      .includes(searchQueryLower);

    return matchesCompanyName || matchesBankList || matchesPincode;
  });

  const indexOfLastCompany = currentPage * companyPerPage;
  const indexOfFirstCompany = indexOfLastCompany - companyPerPage;
  const currentCompanyList = filteredCompanyLists.slice(indexOfFirstCompany, indexOfLastCompany);

  return (
    <div className="home-loan-screen">
      <h4 className="agent-title">Company</h4>
      <div className="agent company-btn">
        <div className="search-bar">
          <input
            type="text"
            placeholder="CompanyName, BankList, Pincode"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
        </div>
        <div className="agent-actions">
          <button className="company-button" onClick={handleStaffButtonClick}>
            <span className="plus-icon">+</span> Add Company
          </button>
          <button className="company-button" onClick={handleBulkUpload}>
            <span className="plus-icon">+</span> Bulk Upload
          </button>
          <button className="agent-button-delete" onClick={handleBulkDelete}>
            <span className="plus-icon">+</span> Bulk Delete
          </button>
        </div>
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Company ID</th>
              <th>Company Name</th>
              <th>Bank List</th>
              <th>Company Pincode</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentCompanyList.length > 0 ? (
              currentCompanyList.map((company, index) => (
                <tr
                  key={index}
                  onClick={() => handleEdit(company.company_id)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{company.company_id}</td>
                  <td>{company.company_name}</td>
                  <td>{getBankNames(company.bank_list)}</td>
                  <td>{company.company_pincode}</td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(company.company_id);
                      }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No Companies found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Paginations
          perPageData={companyPerPage}
          data={filteredCompanyLists}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isShowingPageLength={true}
          paginationDiv="pagination-container"
          paginationClass="pagination"
        />
      </div>
    </div>
  );
};

export default CompanyList;
